import React from "react";
import Sidebar from "../Sidebar";

export default function AppShell({ children, className = "" }) {
  return (
    <div className="d-flex">
      <Sidebar />
      <div className={`app-page${className ? ` ${className}` : ""}`}>{children}</div>
    </div>
  );
}
